import { ROLES } from '../../../authentication/authRoles.constants';
import { Validators } from '@angular/forms';
import { WorkOrderFiltersModel } from '../../components/model/work-order-filters.model';

const DELETABLE_CASING_STATUS: string[] = ['RELEASED', 'EDITABLE', 'INCOMPLETE'];

export const RELEASED = 'RELEASED';
export const ENTERED = 'ENTERED';
export const CLOSED = 'CLOSED';
export const EDITABLE = 'EDITABLE';

export function processCodeToWorkType(processCode: string): string {
  const PROCESS_CODE_TO_WORK_TYPE: { [key: string]: string } = {
    RR: 'RR',
    DS: 'RR',
    BS: 'RR',
    CC: 'RR',
    CP: 'RR',
    RO: 'RO',
    SC: 'SC',
    SO: 'SO',
    NP: 'NP',
    RS: 'RS',
    AD: 'AD',
    IO: 'IO'
  };
  return PROCESS_CODE_TO_WORK_TYPE[processCode] || '';
}

export enum WorkOrderLineEditViolation {
  ERR_MSG_MFG_DOT_1 = 'errMsgMfgDot1Text',
  ERR_MSG_MFG_DOT_2 = 'errMsgMfgDot2Text',
  ERR_MSG_RT_DOT_1 = 'errMsgRtDot1Text',
  ERR_MSG_RT_DOT_2 = 'errMsgRtDot2Text',
  ERR_MSG_RT_DOT_3 = 'errMsgRtDot3Text',
  ERR_MSG_DOT = 'errMsgDotText',
  ERR_MSG_INVALID_SIZE_TREAD = 'errMsgInvalidSizeTreadText',
  ERR_MSG_INVALID_MAKE_SERIES_SIZE_TREAD = 'errMsgInvalidMakeSeriesSizeTreadText',
  WOL_SAVE_SUCCESS = 'wolSaveSuccess',
  WOL_SAVE_FAILED = 'wolSaveFailed',
  ERR_MSG_NO_CHANGES_DETECTED = 'errMsgNoChangesDetected',
  ERR_MSG_BIAS_SIZE_NOT_ALLOWED = 'errMsgBiasSizeNotAllowed',
  ERR_MSG_LOCKED_CASING = 'errMsgLockedCasing',
  ERR_MSG_DUPLICATE_CASING = 'errMsgDuplicateCasing'
}

export function hasWorkOrderEditRoles(): boolean {
  const roles: string = localStorage.getItem('roles') || '';
  return roles.includes(ROLES.view_work_orders) && roles.includes(ROLES.edit_work_orders);
}

export function hasWorkOrderDeleteRoles(): boolean {
  const roles: string = localStorage.getItem('roles') || '';
  return roles.includes(ROLES.delete_casings) && roles.includes(ROLES.delete_casings);
}

export function hasWorkOrderCreateRoles(): boolean {
  const roles: string = localStorage.getItem('roles') || '';
  return roles.includes(ROLES.create_work_orders) && roles.includes(ROLES.create_work_orders);
}

export function enableWorkOrderDelete(): boolean {
  return hasWorkOrderDeleteRoles() && (hasWorkOrderEditRoles() || hasWorkOrderCreateRoles());
}

export function isDeletableCasingStatus(casingStatus: string): boolean {
  return DELETABLE_CASING_STATUS.includes(casingStatus) && enableWorkOrderDelete();
}

export function isWorkOrderLineEditable(lineStatus: string, lockPost: string): boolean {
  const editableStatuses: string[] = ['RELEASED', 'SHOP_FLOOR', 'EDITABLE', 'INCOMPLETE'];
  return editableStatuses.includes(lineStatus) && lockPost === null;
}

export function enableRequiredField(fieldControl: any) {
  fieldControl?.setValidators([Validators.required]);
  fieldControl?.enable({ emitEvent: false });
  fieldControl?.updateValueAndValidity({ emitEvent: false });
}

export const REQUIRED = 'R';

export const defaultWOFilters: WorkOrderFiltersModel = {
  workOrderNumber: '',
  workOrderHeaderPk: '',
  workOrderStatus: [],
  customerCode: '',
  customerName: '',
  crn: '',
  workOrderPlant: [],
  workOrderSite: [],
  workOrderReceivedDateStart: '',
  workOrderReceivedDateEnd: '',
  workOrderDueDateStart: '',
  workOrderDueDateEnd: '',
  searchByUser: ''
};
